import { canEditInterventionAssessmentBody } from './interventionAssessmentEditAccess';
import { canStartInterventionRevision, isEligibleInterventionRevisionSource } from '../lib/interventionRevisionPolicy';

export const resolveInterventionRevisionAction = ({
  intervention = null,
  canModify = false,
  matchingRevisionDraft = null,
  role = null,
  currentStaffProfileId = null,
  assignedStaffProfileId = null,
} = {}) => {
  if (!intervention || !canModify) {
    return { available: false, reason: "not_editable" };
  }

  if (!isEligibleInterventionRevisionSource(intervention)) {
    return { available: false, reason: "status_not_eligible" };
  }

  if (matchingRevisionDraft?.id) {
    const editable = canEditInterventionAssessmentBody({
      role,
      reviewStatus: matchingRevisionDraft.reviewStatus || matchingRevisionDraft.status,
      reviewWorkflow: matchingRevisionDraft.reviewWorkflow || matchingRevisionDraft.review_workflow,
      createdByStaffProfileId: matchingRevisionDraft.createdByStaffProfileId || matchingRevisionDraft.created_by_staff_profile_id,
      currentStaffProfileId,
      assignedStaffProfileId,
      hasExistingIntervention: true,
    });
    return {
      available: true,
      reason: "matching_revision_draft",
      label: editable
        ? matchingRevisionDraft.status === 'draft' ? 'Resume revision draft' : 'Resume revision'
        : 'View revision',
      draft: matchingRevisionDraft,
    };
  }

  if (!canStartInterventionRevision(role)) {
    return { available: false, reason: 'author_role_required' };
  }

  return {
    available: true,
    reason: "revision_available",
    label: "Revise approved intervention",
    draft: null,
  };
};
